import React, { Component } from 'react';

// TODO name the steps here, not just with numbers like stepN!
import Step0 from 'components/wizard/step0/step0';
import Step1 from 'components/wizard/step1/step1';
import Step2 from 'components/wizard/step2/step2';
import Step3 from 'components/wizard/step4/step4';
import Step4 from 'components/wizard/step5/step5';

import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { updateForm } from 'components/wizard/container/actions';
import RegisterSuccess from 'components/pages/RegisterSuccess';
import { Alert } from 'reactstrap';
import axios from 'axios';

// Header and Footer
import Header from 'components/header/header';
import PopUp from 'components/pop-up/pop-up';

// Transform submission from props data before sending to server
import SubmissionTransformer from './submissionTransformer';

import styles from './container.module.scss';

// Correspond to steps in Wizard, displayed with navigation bar
// TODO Refactor these items to the stepN.js files
const items = [
  { text: '', key: 'landing-page' },
  { text: 'Agency Information', key: 'agency-info' },
  { text: 'Contact Information', key: 'contact-info' },
  { text: 'Errors and Omissions Policy Information', key: 'errors-omissions' },
  { text: 'Agency Eligibility Questionnaire', key: 'agency-eligibility' },
  { text: 'Upload Documents', key: 'document-uploads' }
];
// Components for steps above
const steps = [Step0, Step1, Step2, Step3, Step4];

class Container extends Component {
  state = {
    errorMessages: [],
    submissionProgress: 0,
    isSubmitting: false,
    response: '',
    popUpData: { title: "", body: "", show: false },
    nextStep: false,
    registerData: '',
    loading: false,
    formDefinitions: {},
  };

  // Used for advancing steps forward in Registration Wizard
  onNext = async () => {
    this.setState({ errorMessages: [] });
    // const progress = this.props.values.progress;
    const currentStep = this.props.values.currentStep;

    // Forms on all steps submitted together via this container
    if (currentStep >= steps.length) {
      return await this.onSubmit();
    }

    if (currentStep === 1) {
      await this.callAPI();
      await this.getFormDefinitions();
    }

    if (currentStep !== 2 || !this.state.nextStep) {
      this.props.updateValues({ currentStep: currentStep + 1 });
    }
  };

  getFormDefinitions = async () => {

    const endpointUrl = `${window.environmentConfig.BTIS_BASE_API_URL}v1/agentregistration/Affiliate`
    const affiliatesResponse = await axios
      .get(endpointUrl)
      .catch(error => {
        console.log(error);
      });

    const rawAffiliates = (affiliatesResponse?.data?.response ?? affiliatesResponse?.data?.Response ?? [])
      .map(x => (
        {
          name: x.name || x.Name,
          value: x.id || x.Id,
          systemFieldName: x.systemFieldName || x.SystemFieldName,
          normalizedName: (x.name || x.Name)
            .toLowerCase()
            .replace(/\s/g, '')
        }))
      .sort((a, b) => a.name < b.name ? -1 : 1);

    let affiliates = rawAffiliates;
    const defaultAffiliate = sessionStorage.getItem("affiliate")
      ?.toLowerCase()
      ?.replace(/\s/g, '');

    if (defaultAffiliate && rawAffiliates.filter(ra => ra.normalizedName.indexOf(defaultAffiliate) === 0).length) {
      affiliates = rawAffiliates.filter(a => a.normalizedName === defaultAffiliate);
    }

    this.setState(
      {
        ...this.state,
        formDefinitions:
        {
          ...this.state.formDefinitions,
          affiliates
        }
      });
  };

  callAPI = async () => {

    let niprendpoint = this.props.urls.niprApiUrl;
    this.setState({ loading: true, response: '' });
    if ((this.props.values.State && this.props.values.AgentLicense)) {
      const data1 = await axios.post(niprendpoint,
        {
          Licence_num: this.props.values.AgentLicense,
          State: this.props.values.State
        })

        .catch(error => {
          this.setState(
            {
              nextStep: true,
              popUpData: {
                show: true,
                title: "Looks like something has went wrong.",
                body: " Please try again later or continue to enter the information manually."
              }
            }
          );
          return false;
        })
        .finally(() => this.setState({ loading: false }));

      if (data1.data?.result?.entityinfo) {
        this.setState({ response: data1.data });
      }
      else {
        this.setState(
          {

            nextStep: true,
            popUpData: {
              show: true,
              title: "No Match Found, But You’re Almost There!",
              body: "We couldn’t find any records with the information you provided, but no worries! You can easily continue and enter your agency details manually.\nIf you'd like, click 'Try Again' to adjust your search, or click 'Continue' to proceed."

            }
          }
        );
        this.resetExternalApiData();
      }

    }
    else if (this.props.values.FEIN) {
      const data1 = await axios.post(niprendpoint,
        {
          fein: this.props.values.FEIN,
        })
        .catch(error => {
          this.setState(
            {
              nextStep: true,
              popUpData: {
                show: true,
                title: "Looks like something has went wrong.",
                body: " Please try again later or continue to enter the information manually."
              }
            }
          );
          return false;
        })
        .finally(() => this.setState({ loading: false }));

      if (data1.data?.result?.entityinfo) {
        this.setState({ response: data1.data });
        this.props.updateValues(
          {
            State: (data1.data.result.entityinfo?.ContactInfo?.State || '')
          });
      }
      else {
        this.setState(
          {
            nextStep: true,
            popUpData: {
              show: true,
              title: "No Records Found",
              body: "No records were found with the search criteria entered. Please click Try Again to change the search criteria or click Continue to proceed with manually entering your agency information."
            }
          }
        );
        this.resetExternalApiData();
      }
    }
  }

  /* setStep updates the props being passed to the chlid component (e.g. Step1)
   *  from this wrapper component.
   */
  setStep = step => {
    if (step >= this.props.values.progress) {
      this.props.updateValues({ currentStep: step });
    }
  };

  onSubmit = async () => {
    // This function gets called in the onSubmit in step6.js

    // Endpoint is read in from public/config.js, linked in public/index.html
    // In App.js, these values are saved by dispatching url/UPDATE_SITE,
    // making them accessible in the redux store.
    window.scroll(0, 0);
    let endpoint = this.props.urls.btisApiUrl;

    var messages = [];
    this.setState({ isSubmitting: true, errorMessages: messages });

    // Transform form data to appropriate schema
    let submission = SubmissionTransformer(this.props.values);
    if ((this.state.response === "") || (submission.Violation || submission.EAndOClaimsInPastFive || submission.BankruptcyInPastFive || submission.OpenLiens)) {
      submission.NIPRRecord = false;
    }
    else {
      submission.NIPRRecord = true
    }
    this.setState({ registerData: submission });
    const form_data = new FormData();

    // Append text fields to form data
    Object.keys(submission).forEach(key => {
      form_data.append(key, submission[key]);
    });

    if (this.props.urls.source) {
      form_data.append("RequestSource", this.props.urls.source);
    }

    let submission_result = messages.length === 0 &&
      await axios
        .post(endpoint, submission)
        .then(function (response) {
          if (window.fbq) {
            window.fbq('track', 'CompleteRegistration', {
              "content_name": (submission?.AgencyName || ''),
              "status": true
            });
          }

          return true;
        })
        .catch(function (error) {
          if (error.length > 0) {
            for (let idx = 0; idx < error.length; idx++) {
              if (Array.isArray(error[idx])) {
                for (let idx2 = 0; idx2 < error[idx].length; idx2++) {
                  messages.push(error[idx][idx2]);
                }
              }
              else {
                messages.push(error[idx]);
              }
            }
          }
          else {
            messages.push(error);
            try{
              // const errorObj = error?.response?.data?.errors;
              // const values = errorObj ? Object.values(errorObj) : [];
              // const flatList = values?.flat();
              // flatList?.forEach( err => {
              //   messages.push(err)
              // });  
            }catch(err){
              console.log(err);
            }
            messages.push("Please check your entries.");
          }

          return false;
        });

    // Render response depending on success of axios post call
    if (submission_result) {
      this.props.updateValues({ currentStep: 'success' });
    }
    else {
      messages.unshift('Error submitting form.');
      this.setState({ errorMessages: messages });
    }

    this.setState({
      isSubmitting: false
    });
  };

  resetPopUp = () => {
    this.setState(
      {
        popUpData: {
          show: false,
          title: "",
          body: ""
        }
      }
    );
  };

  resetExternalApiData = () => {
    this.props.updateValues({
      AgencyName: '',
      FederalTaxId: '',
      TaxIDName: '',
      LicenseNo: '',
      PrincipalName: '',
      PrincipalEmail: '',
      address1: '',
      City: '',
      State: '',
      Zip: '',
      PhoneNumber: '',
      ContactName: '',
      ContactEmail: '',
    });
  }

  continueNext = () => {
    this.onNext();
    this.setState({ nextStep: false });

  }

  render() {
    if (this.props.match.params.step === 'success') {
      // TODO redirect to new route
      return (
        <RegisterSuccess
          registerData={this.state.registerData}
          response={this.state.response}
        />
      );
    }


    const urlStep = parseInt(this.props.match.params.step || 1);
    const currentStep = this.props.values.currentStep;


    if (urlStep !== currentStep && !this.state.nextStep) {
      return <Redirect to={`/register/wizard/${currentStep}`} />;
    }

    const WizardStep = steps[urlStep - 1];

    return (
      <>
        <Header />
        <main>
          {/* This section only appears while the completed forms are being submitted. */}
          <section className="container">
            {this.state.isSubmitting ? (
              <h2>Submitting... {this.state.submissionProgress.toFixed(0)}%</h2>
            ) : null}
          </section>

          {urlStep === 1 ? (
            <Step0
              loading={this.state.loading}
              updateValues={this.props.updateValues}
              values={this.props.values}
              onNext={this.onNext}
              step={urlStep}
              setStep={this.setStep}
            />
          ) : (
            <section className="container">
              {
                currentStep >= steps.length ? (
                  <section className="row justify-content-center">
                    <Alert
                      color="danger"
                      isOpen={this.state.errorMessages.length > 0}
                      className="col-10"
                    >
                      <h4 className="alert-heading">
                        Please check your entries:
                      </h4>
                      {
                        this.state.errorMessages ? (
                          <>
                            <p>
                              Form submission failed. See the error message(s)
                              below:
                            </p>
                            <ul>
                              {this.state.errorMessages.map((message, index) => (
                                <li key={index}>{message.toString()}</li>
                              ))}
                            </ul>
                          </>
                        ) : (
                          <></>
                        )
                      }
                    </Alert>
                  </section>
                ) : null}

              <section className="row justify-content-center">
                {/* "Main" column 
                   Initial landing page does not use this container so it can span entire screen width
                */}
                {!this.state.nextStep ? (
                  <div className={urlStep > 1 && 'col-md-8 col-lg-9 px-0 mx-0'}>
                    {/* Step name, e.g. 'Agency Information' */}
                    <header className="mb-4 mt-4">
                      <h2 className={'text-center ' + styles.stepName}>
                        {items[urlStep - 1].text}
                      </h2>
                    </header>

                    {/* Main Wizard Content */}
                    <WizardStep
                      updateValues={this.props.updateValues}
                      values={this.props.values}
                      onNext={this.onNext}
                      onSubmit={this.onSubmit}
                      submissionProgress={this.state.submissionProgress}
                      step={urlStep}
                      setStep={this.setStep}
                      response={this.state.response}
                      formDefinitions={this.state.formDefinitions}
                    />
                  </div>
                ) : null}
              </section>
            </section>
          )}
        </main>
        {(this.state.popUpData.show && this.state.nextStep) ? (
          <PopUp
            title={this.state.popUpData.title}
            body={this.state.popUpData.body}
            show={this.state.popUpData.show}
            resetPopUp={this.resetPopUp}
            onContinue={this.continueNext}
          />
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    values: state.wizard,
    urls: state.url
  };
};

const mapDispatchToProps = {
  updateValues: updateForm // (Redux) action to dispatch
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Container)
);
